import { render } from "./OkbReport.vue?vue&type=template&id=4f31e314"
import script from "./OkbReport.vue?vue&type=script&lang=js"
export * from "./OkbReport.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__